import React from 'react';
import { FeedPage } from '@go-shared/types/feedTemplate';
import { BubbleButton } from '@go-client/components/BubbleUI';

interface FeedEditorPagesProps {
  pages: FeedPage[];
  currentPage?: FeedPage;
  onPageClick: (page: FeedPage) => void;
}

export const FeedEditorPages: React.FC<FeedEditorPagesProps> = ({
  pages,
  currentPage,
  onPageClick,
}) => {
  return (
    <>
      {pages.map((page, i) => (
        <BubbleButton
          key={i}
          block
          variant="ocean"
          appearance="squared"
          inverse={currentPage && currentPage._id !== page._id}
          className="text-left"
          onClick={() => onPageClick(page)}
        >
          Page {i + 1}
        </BubbleButton>
      ))}
    </>
  );
};
